exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n.dropdown_dropdown_yOinO {\n    border: 1px solid #E9EEF2;\n    border-radius: 5px;\n    overflow: visible;\n    min-width: 3.5rem;\n    color: #4C97FF;\n    padding: .5rem;\n}\n\n.dropdown_mod-open_3zJSJ {\n    background-color: #E9EEF2;\n}\n\n.dropdown_dropdown-icon_3W56D {\n    width: .5rem;\n    height: .5rem;\n    vertical-align: middle;\n    padding-bottom: .2rem;\n}\n\n[dir=\"ltr\"] .dropdown_dropdown-icon_3W56D {\n    margin-left: .5rem;\n}\n\n[dir=\"rtl\"] .dropdown_dropdown-icon_3W56D {\n    margin-right: .5rem;\n}\n\n.dropdown_mod-caret-up_lmROH {\n    -webkit-transform: rotate(180deg);\n        -ms-transform: rotate(180deg);\n            transform: rotate(180deg);\n    padding-bottom: 0;\n    padding-top: .2rem;\n}\n", ""]);

// exports
exports.locals = {
	"dropdown": "dropdown_dropdown_yOinO",
	"mod-open": "dropdown_mod-open_3zJSJ",
	"modOpen": "dropdown_mod-open_3zJSJ",
	"dropdown-icon": "dropdown_dropdown-icon_3W56D",
	"dropdownIcon": "dropdown_dropdown-icon_3W56D",
	"mod-caret-up": "dropdown_mod-caret-up_lmROH",
	"modCaretUp": "dropdown_mod-caret-up_lmROH"
};